
/**
 * Calculates a score based on questionnaire answers.
 * @param answers - Array of boolean values (true = 'yes', false = 'no')
 * @returns A score from 0-100 where higher is better (less anemia symptoms)
 */
export const calculateScore = (answers: boolean[]): number => {
  // Count "yes" answers (which indicate anemia symptoms)
  const yesCount = answers.filter(answer => answer).length;
  
  // Calculate score - each "yes" reduces score by 20 points (5 questions total)
  const score = 100 - (yesCount * 20);
  
  return score;
};

/**
 * Interprets a score into a risk category.
 * @param score - Numerical score from 0-100
 * @returns Risk category string
 */
export const interpretScore = (score: number): 'high' | 'moderate' | 'low' => {
  if (score <= 50) {
    return 'high';
  } else if (score <= 80) {
    return 'moderate';
  } else {
    return 'low';
  }
};

/**
 * Gets a display-friendly risk category in Spanish based on the numerical score.
 * @param score - Numerical score from 0-100 
 * @returns Risk category string in Spanish
 */
export const getSpanishRiskCategory = (score: number): string => {
  if (score <= 50) {
    return 'Alto riesgo';
  } else if (score <= 80) {
    return 'Riesgo moderado';
  } else {
    return 'Bajo riesgo';
  }
};

/**
 * Gets the appropriate icon type based on the score.
 * @param score - Numerical score from 0-100
 * @returns Icon type string
 */
export const getScoreIconType = (score: number): 'smile' | 'meh' | 'frown' => {
  if (score <= 50) {
    return 'frown';
  } else if (score <= 80) {
    return 'meh';
  } else {
    return 'smile';
  }
};

/**
 * Gets the appropriate color based on the score.
 * @param score - Numerical score from 0-100
 * @returns Color name
 */
export const getScoreColor = (score: number): string => {
  if (score <= 50) {
    return 'sangre';
  } else if (score <= 80) {
    return 'warning';
  } else {
    return 'fuerte';
  }
};
